module.exports = "/static/img/javascript.svg?b65a8f9d1d85a295f13fb8a9442fdd17";